const translations = {
  en: {
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.myWork': 'My Work',
    'nav.assetLookup': 'Search Assets',
    'nav.workOrders': 'Work Orders',
    'nav.myTeam': 'My Team',
    'nav.supervisor': 'Team Manager',
    'nav.helpCentre': 'Help Centre',
    'nav.adminPanel': 'Administration',
    'nav.settings': 'Settings',
    'nav.signOut': 'Sign Out',
    'nav.projects': 'Projects',
    'nav.todos': 'To Do',
    'nav.credentials': 'Credential Vault',

    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.close': 'Close',
    'common.search': 'Search',
    'common.loading': 'Loading...',
    'common.noResults': 'No results found',
    'common.confirm': 'Confirm',
    'common.back': 'Back',
    'common.export': 'Export',
    'common.all': 'All',
    'common.allTypes': 'All Types',
    'common.yes': 'Yes',
    'common.no': 'No',

    // Work Orders
    'wo.title': 'Work Orders',
    'wo.newNotification': 'New Notification',
    'wo.newSubNotification': 'New Sub Notification',
    'wo.searchPlaceholder': 'Search work orders...',
    'wo.noWorkOrders': 'No work orders found',
    'wo.total': '{count} total work orders',
    'wo.editWorkOrder': 'Edit Work Order',
    'wo.viewMode': 'View Mode',
    'wo.shopPaper': 'Shop Paper',
    'wo.status': 'Status',
    'wo.priority': 'Priority',
    'wo.type': 'Type',
    'wo.assignedTo': 'Assigned To',
    'wo.dueDate': 'Due Date',
    'wo.createdBy': 'Created By',
    'wo.description': 'Description',
    'wo.operations': 'Operations',
    'wo.timeConfirmations': 'Time Confirmations',
    'wo.comments': 'Comments',
    'wo.attachments': 'Attachments',
    'wo.history': 'History',
    'wo.overdue': 'OVERDUE',

    // Supervisor Panel
    'supervisor.title': 'Supervisor Panel',
    'supervisor.notifications': 'Notifications',
    'supervisor.outstanding': 'Outstanding',
    'supervisor.notConfirmed': 'Not Confirmed',
    'supervisor.jobsToTeco': 'Jobs to TECO',
    'supervisor.overdueJobs': 'Overdue Jobs',
    'supervisor.capacity': 'Capacity',
    'supervisor.myTeam': 'My Team',
    'supervisor.approve': 'Approve',
    'supervisor.reject': 'Reject',
    'supervisor.noPending': 'No pending notifications',
    'supervisor.pendingDesc': 'Notifications awaiting approval will appear here',

    // Dashboard
    'dashboard.title': 'Dashboard',
    'dashboard.welcome': 'Welcome back, {name}',
    'dashboard.openJobs': 'Open Jobs',
    'dashboard.overdueJobs': 'Overdue Jobs',
    'dashboard.completedThisWeek': 'Completed This Week',
    'dashboard.dueThisWeek': 'Due This Week',

    // Assets
    'assets.title': 'Asset Lookup',
    'assets.searchPlaceholder': 'Search assets...',
    'assets.noAssets': 'No assets found',

    // My Work
    'myWork.title': 'My Work',
    'myWork.noTasks': 'No tasks assigned',

    // Teams
    'teams.title': 'My Team',
    'teams.noTeams': 'No teams have been created yet',

    // Settings
    'settings.title': 'Settings',
    'settings.profile': 'Profile',
    'settings.language': 'Language',
    'settings.theme': 'Theme',
    'settings.notifications': 'Email Notifications',

    // Help Centre
    'help.title': 'Help Centre',
    'help.subtitle': 'Learn how the system works',
    'help.workflowTitle': 'Notification to Work Order Workflow',

    // Auth
    'auth.signIn': 'Sign In',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.forgotPassword': 'Forgot password?',
    'auth.resetPassword': 'Reset Password',

    // Landing Page
    'landing.getApp': 'Get App',
    'landing.signIn': 'Sign In',
    'landing.heroSubtitle': 'Professional asset management and work order tracking. Streamline maintenance, automate scheduling, and keep your team on track.',
    'landing.getStarted': 'Get Started',
    'landing.downloadApp': 'Download App',
    'landing.featuresTitle': 'Everything You Need',
    'landing.featuresSubtitle': 'A complete maintenance management platform built for real-world operations.',
    'landing.feature1Title': 'Work Order Management',
    'landing.feature1Desc': 'Notification-to-work-order workflow with supervisor approval. Create, assign, and track PM01, PM02, and PM03 work orders.',
    'landing.feature2Title': 'Asset Tracking',
    'landing.feature2Desc': 'Comprehensive asset registry with detailed profiles, linked work orders, and document attachments.',
    'landing.feature3Title': 'Recurring Job Scheduling',
    'landing.feature3Desc': 'Automate PM02 recurring maintenance with flexible frequencies from daily to yearly.',
    'landing.feature4Title': 'Team & Supervisor Panel',
    'landing.feature4Desc': 'Manage teams with org chart, supervisor-approved transfers, capacity planning, and adherence tracking.',
    'landing.feature5Title': 'Document Management',
    'landing.feature5Desc': 'Upload images, videos, and documents with thumbnails, download buttons, and auto-organized filenames.',
    'landing.feature6Title': 'Dashboard & Analytics',
    'landing.feature6Desc': 'Real-time overview with charts, stats, overdue alerts, and job load visualization.',
    'landing.feature7Title': 'Time Confirmations',
    'landing.feature7Desc': 'Log hours against operations with NEW/PCNF/CNF status tracking — see at a glance which jobs are New, Partially Confirmed, or fully Confirmed.',
    'landing.feature8Title': 'Email Notifications',
    'landing.feature8Desc': 'Automated daily/weekly summaries, assignment alerts, due date reminders, and adherence reports.',
    'landing.feature9Title': 'KPT Permissions',
    'landing.feature9Desc': 'Key Permission Types let admins create named permission groups with granular controls: approvals, TECO, notifications, licences, and team management.',
    'landing.feature10Title': 'Mobile App',
    'landing.feature10Desc': 'Native Android and iOS apps with push notifications for on-the-go field access.',
    'landing.feature11Title': 'Capacity Planning',
    'landing.feature11Desc': 'Visual bar charts of team utilization, working hours configuration, and workload balancing.',
    'landing.feature12Title': 'Scheduling & Templates',
    'landing.feature12Desc': 'Work order templates, sub-work orders, job load calendar, and automated recurring generation.',
    'landing.feature13Title': 'Project Management',
    'landing.feature13Desc': 'Kanban board with drag-and-drop, project tracking with completion percentages, member roles, and deadline management.',
    'landing.feature14Title': 'Sub Notifications',
    'landing.feature14Desc': 'Create sub work orders under any parent with inherited asset selection, multi-operation support, and supervisor approval workflow.',
    'landing.feature15Title': 'TECO Workflow',
    'landing.feature15Desc': 'Full technical completion lifecycle — request TECO, supervisor approval, and admin UN-TECO to reopen with confirmed operations preserved.',
    'landing.feature16Title': 'Legacy WO Linking',
    'landing.feature16Desc': 'Link legacy work orders to PM02 templates for historical tracking without triggering automatic rescheduling.',
    'landing.woTypesTitle': 'Three Work Order Types',
    'landing.woTypesSubtitle': 'Cover every maintenance scenario with purpose-built work order classifications.',
    'landing.pm01Label': 'Planned',
    'landing.pm01Desc': 'Scheduled maintenance tasks with due dates and job load balancing. Plan work ahead with date-based scheduling and team assignment.',
    'landing.pm02Label': 'Recurring',
    'landing.pm02Desc': 'Automated recurring jobs with configurable frequencies. Set it once and the system generates work orders on schedule.',
    'landing.pm03Label': 'Unplanned',
    'landing.pm03Desc': 'Reactive work orders for breakdowns and urgent issues. Auto-assigned to today with immediate In Progress status.',
    'landing.workflowTitle': 'Simple Approval Workflow',
    'landing.workflowSubtitle': 'From notification to work order in just a few clicks. Every job goes through a clear approval process.',
    'landing.step1Title': 'Notification Created',
    'landing.step1Desc': 'User submits a notification describing the work needed',
    'landing.step2Title': 'Supervisor Reviews',
    'landing.step2Sub': 'Supervisor Panel',
    'landing.step2Desc': 'Appears in the Notifications tab for review',
    'landing.step3Title': 'Approved',
    'landing.step3Sub': 'One-click approval',
    'landing.step3Desc': 'Supervisor approves and notification converts automatically',
    'landing.step4Title': 'Work Order Live',
    'landing.step4Desc': 'Full work order created with operations and scheduling',
    'landing.highlightsTitle': 'Built for Teams',
    'landing.highlightsSubtitle': 'From solo technicians to full maintenance departments.',
    'landing.highlight1': 'Unique 9-digit work order numbers for every job',
    'landing.highlight2': 'Full audit history tracking every field change',
    'landing.highlight3': 'My Work panel shows your assigned and overdue tasks',
    'landing.highlight4': 'Admin panel for user, asset, supplier, and location management',
    'landing.highlight5': 'Image, video, and document attachments with previews',
    'landing.highlight6': 'Job load graph helps balance work across dates',
    'landing.highlight7': 'Priority levels with color-coded visual indicators',
    'landing.highlight8': 'Mobile-responsive design works on any device',
    'landing.highlight9': 'Supervisor panel with team oversight and approvals',
    'landing.highlight10': 'Weekly adherence reports sent to administrators',
    'landing.highlight11': 'Dark mode with per-user theme preferences',
    'landing.highlight12': 'Custom site branding with logo and favicon',
    'landing.pricingTitle': 'Simple Pricing',
    'landing.pricingSubtitle': 'Straightforward plans in AUD. No hidden fees.',
    'landing.mostPopular': 'Most Popular',
    'landing.starter': 'Starter',
    'landing.starterDesc': 'For small teams getting started',
    'landing.professional': 'Professional',
    'landing.professionalDesc': 'For growing maintenance teams',
    'landing.enterprise': 'Enterprise',
    'landing.enterpriseDesc': 'For large organisations',
    'landing.upTo5': 'Up to 5 users',
    'landing.woManagement': 'Work order management',
    'landing.assetTracking': 'Asset tracking',
    'landing.mobileAccess': 'Mobile app access',
    'landing.emailNotif': 'Email notifications',
    'landing.upTo25': 'Up to 25 users',
    'landing.everythingStarter': 'Everything in Starter',
    'landing.recurringScheduling': 'Recurring scheduling',
    'landing.supervisorPanel': 'Supervisor panel',
    'landing.capacityPlanning': 'Capacity planning',
    'landing.weeklyReports': 'Weekly adherence reports',
    'landing.customBranding': 'Custom branding',
    'landing.unlimitedUsers': 'Unlimited users',
    'landing.everythingPro': 'Everything in Professional',
    'landing.prioritySupport': 'Priority support',
    'landing.customIntegrations': 'Custom integrations',
    'landing.onPremise': 'On-premise option',
    'landing.sla': 'SLA guarantee',
    'landing.mobileTitle': 'Take It With You',
    'landing.mobileSubtitle': 'Download the mobile app for on-the-go access. Create work orders, upload photos, and get live alerts right from the field.',
    'landing.autoUpdate': 'Always downloads the latest version — auto-update enforced',
  },

  es: {
    'nav.dashboard': 'Panel',
    'nav.myWork': 'Mi Trabajo',
    'nav.assetLookup': 'Buscar Activos',
    'nav.workOrders': 'Ordenes de Trabajo',
    'nav.myTeam': 'Mi Equipo',
    'nav.supervisor': 'Gestor de Equipo',
    'nav.helpCentre': 'Centro de Ayuda',
    'nav.adminPanel': 'Panel de Admin',
    'nav.settings': 'Configuracion',
    'nav.signOut': 'Cerrar Sesion',
    'nav.projects': 'Proyectos',
    'nav.todos': 'Tareas',
    'nav.credentials': 'Bóveda de Credenciales',
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.close': 'Cerrar',
    'common.search': 'Buscar',
    'common.loading': 'Cargando...',
    'common.noResults': 'Sin resultados',
    'common.confirm': 'Confirmar',
    'common.back': 'Volver',
    'common.export': 'Exportar',
    'common.all': 'Todos',
    'common.allTypes': 'Todos los Tipos',
    'common.yes': 'Si',
    'common.no': 'No',
    'wo.title': 'Ordenes de Trabajo',
    'wo.newNotification': 'Nueva Notificacion',
    'wo.newSubNotification': 'Nueva Sub Notificacion',
    'wo.searchPlaceholder': 'Buscar ordenes de trabajo...',
    'wo.noWorkOrders': 'No se encontraron ordenes de trabajo',
    'wo.total': '{count} ordenes de trabajo en total',
    'wo.editWorkOrder': 'Editar Orden de Trabajo',
    'wo.viewMode': 'Modo Vista',
    'wo.shopPaper': 'Hoja de Taller',
    'wo.status': 'Estado',
    'wo.priority': 'Prioridad',
    'wo.type': 'Tipo',
    'wo.assignedTo': 'Asignado A',
    'wo.dueDate': 'Fecha de Vencimiento',
    'wo.createdBy': 'Creado Por',
    'wo.description': 'Descripcion',
    'wo.operations': 'Operaciones',
    'wo.timeConfirmations': 'Confirmaciones de Tiempo',
    'wo.comments': 'Comentarios',
    'wo.attachments': 'Archivos Adjuntos',
    'wo.history': 'Historial',
    'wo.overdue': 'VENCIDO',
    'supervisor.title': 'Panel de Supervisor',
    'supervisor.notifications': 'Notificaciones',
    'supervisor.outstanding': 'Pendientes',
    'supervisor.notConfirmed': 'Sin Confirmar',
    'supervisor.jobsToTeco': 'Trabajos para TECO',
    'supervisor.overdueJobs': 'Trabajos Vencidos',
    'supervisor.capacity': 'Capacidad',
    'supervisor.myTeam': 'Mi Equipo',
    'supervisor.approve': 'Aprobar',
    'supervisor.reject': 'Rechazar',
    'supervisor.noPending': 'Sin notificaciones pendientes',
    'supervisor.pendingDesc': 'Las notificaciones pendientes de aprobacion apareceran aqui',
    'dashboard.title': 'Panel',
    'dashboard.welcome': 'Bienvenido, {name}',
    'dashboard.openJobs': 'Trabajos Abiertos',
    'dashboard.overdueJobs': 'Trabajos Vencidos',
    'dashboard.completedThisWeek': 'Completados Esta Semana',
    'dashboard.dueThisWeek': 'Vencen Esta Semana',
    'assets.title': 'Buscar Activos',
    'assets.searchPlaceholder': 'Buscar activos...',
    'assets.noAssets': 'No se encontraron activos',
    'myWork.title': 'Mi Trabajo',
    'myWork.noTasks': 'Sin tareas asignadas',
    'teams.title': 'Mi Equipo',
    'teams.noTeams': 'No se han creado equipos aun',
    'settings.title': 'Configuracion',
    'settings.profile': 'Perfil',
    'settings.language': 'Idioma',
    'settings.theme': 'Tema',
    'settings.notifications': 'Notificaciones por Email',
    'help.title': 'Centro de Ayuda',
    'help.subtitle': 'Aprende como funciona el sistema',
    'help.workflowTitle': 'Flujo de Notificacion a Orden de Trabajo',
    'auth.signIn': 'Iniciar Sesion',
    'auth.email': 'Correo Electronico',
    'auth.password': 'Contrasena',
    'auth.forgotPassword': 'Olvido su contrasena?',
    'auth.resetPassword': 'Restablecer Contrasena',
    'landing.getApp': 'Obtener App',
    'landing.signIn': 'Iniciar Sesion',
    'landing.heroSubtitle': 'Gestion profesional de activos y seguimiento de ordenes de trabajo. Optimice el mantenimiento, automatice la programacion y mantenga a su equipo al dia.',
    'landing.getStarted': 'Comenzar',
    'landing.downloadApp': 'Descargar App',
    'landing.featuresTitle': 'Todo lo que Necesitas',
    'landing.featuresSubtitle': 'Una plataforma completa de gestion de mantenimiento construida para operaciones reales.',
    'landing.feature1Title': 'Gestion de Ordenes de Trabajo',
    'landing.feature1Desc': 'Cree, asigne y rastree ordenes de trabajo PM01, PM02 y PM03 con historial completo y flujo de estados.',
    'landing.feature2Title': 'Seguimiento de Activos',
    'landing.feature2Desc': 'Registro integral de activos con perfiles detallados, ordenes de trabajo vinculadas y documentos adjuntos.',
    'landing.feature3Title': 'Programacion Recurrente',
    'landing.feature3Desc': 'Automatice el mantenimiento recurrente PM02 con frecuencias flexibles desde diario hasta anual.',
    'landing.feature4Title': 'Equipo y Panel de Supervisor',
    'landing.feature4Desc': 'Gestione equipos con permisos por grupo, supervision, planificacion de capacidad y seguimiento de cumplimiento.',
    'landing.feature5Title': 'Gestion de Documentos',
    'landing.feature5Desc': 'Suba imagenes, videos y documentos a ordenes de trabajo y activos con vista previa.',
    'landing.feature6Title': 'Panel y Analitica',
    'landing.feature6Desc': 'Vista general en tiempo real con graficos, estadisticas, alertas de vencimiento y carga de trabajo.',
    'landing.feature7Title': 'Confirmaciones de Tiempo',
    'landing.feature7Desc': 'Registre horas contra ordenes de trabajo con seguimiento de tiempo y aprobaciones TECO.',
    'landing.feature8Title': 'Notificaciones por Email',
    'landing.feature8Desc': 'Resumenes automaticos diarios/semanales, alertas de asignacion y recordatorios de vencimiento.',
    'landing.feature9Title': 'Acceso Basado en Roles',
    'landing.feature9Desc': 'Roles de Admin, Supervisor y Usuario con permisos KPT y acceso basado en grupos.',
    'landing.feature10Title': 'App Movil',
    'landing.feature10Desc': 'Apps nativas para Android e iOS con notificaciones push para acceso en campo.',
    'landing.feature11Title': 'Planificacion de Capacidad',
    'landing.feature11Desc': 'Graficos de utilizacion del equipo, configuracion de horas laborales y balance de carga.',
    'landing.feature12Title': 'Programacion y Plantillas',
    'landing.feature12Desc': 'Plantillas de ordenes de trabajo, sub-ordenes, calendario de carga y generacion recurrente automatica.',
    'landing.woTypesTitle': 'Tres Tipos de Ordenes de Trabajo',
    'landing.woTypesSubtitle': 'Cubra cada escenario de mantenimiento con clasificaciones de ordenes de trabajo especificas.',
    'landing.pm01Label': 'Planificado',
    'landing.pm01Desc': 'Tareas de mantenimiento programadas con fechas de vencimiento y balance de carga.',
    'landing.pm02Label': 'Recurrente',
    'landing.pm02Desc': 'Trabajos recurrentes automatizados con frecuencias configurables.',
    'landing.pm03Label': 'No Planificado',
    'landing.pm03Desc': 'Ordenes de trabajo reactivas para averias y problemas urgentes.',
    'landing.workflowTitle': 'Flujo de Aprobacion Simple',
    'landing.workflowSubtitle': 'De notificacion a orden de trabajo en pocos clics. Cada trabajo pasa por un proceso de aprobacion claro.',
    'landing.step1Title': 'Notificacion Creada',
    'landing.step1Desc': 'El usuario envia una notificacion describiendo el trabajo necesario',
    'landing.step2Title': 'Revision del Supervisor',
    'landing.step2Sub': 'Panel de Supervisor',
    'landing.step2Desc': 'Aparece en la pestana de Notificaciones para revision',
    'landing.step3Title': 'Aprobado',
    'landing.step3Sub': 'Aprobacion con un clic',
    'landing.step3Desc': 'El supervisor aprueba y la notificacion se convierte automaticamente',
    'landing.step4Title': 'Orden de Trabajo Activa',
    'landing.step4Desc': 'Se crea una orden de trabajo completa con operaciones y programacion',
    'landing.feature13Title': 'Gestion de Proyectos',
    'landing.feature13Desc': 'Tablero Kanban con arrastrar y soltar, seguimiento de proyectos con porcentajes de finalizacion, roles de miembros y gestion de plazos.',
    'landing.feature14Title': 'Sub Notificaciones',
    'landing.feature14Desc': 'Cree sub ordenes de trabajo bajo cualquier padre con seleccion de activo heredada, soporte multi-operacion y flujo de aprobacion del supervisor.',
    'landing.feature15Title': 'Flujo TECO',
    'landing.feature15Desc': 'Ciclo completo de finalizacion tecnica — solicitar TECO, aprobacion del supervisor y UN-TECO por admin para reabrir.',
    'landing.feature16Title': 'Vinculacion Legacy',
    'landing.feature16Desc': 'Vincule ordenes de trabajo antiguas a plantillas PM02 para seguimiento historico sin activar reprogramacion automatica.',
    'landing.highlightsTitle': 'Hecho para Equipos',
    'landing.highlightsSubtitle': 'Desde tecnicos individuales hasta departamentos de mantenimiento completos.',
    'landing.highlight1': 'Numeros unicos de 9 digitos para cada orden de trabajo',
    'landing.highlight2': 'Historial de auditoria completo de cada cambio de campo',
    'landing.highlight3': 'Panel Mi Trabajo muestra tareas asignadas y vencidas',
    'landing.highlight4': 'Panel de admin para usuarios, activos, proveedores y ubicaciones',
    'landing.highlight5': 'Adjuntos de imagen, video y documentos con vista previa',
    'landing.highlight6': 'Grafico de carga de trabajo para balancear entre fechas',
    'landing.highlight7': 'Niveles de prioridad con indicadores visuales por color',
    'landing.highlight8': 'Diseno responsive que funciona en cualquier dispositivo',
    'landing.highlight9': 'Panel de supervisor con supervision y aprobaciones',
    'landing.highlight10': 'Informes semanales de cumplimiento enviados a administradores',
    'landing.highlight11': 'Modo oscuro con preferencias de tema por usuario',
    'landing.highlight12': 'Marca personalizada del sitio con logo y favicon',
    'landing.pricingTitle': 'Precios Simples',
    'landing.pricingSubtitle': 'Planes claros en AUD. Sin cargos ocultos.',
    'landing.mostPopular': 'Mas Popular',
    'landing.starter': 'Inicial',
    'landing.starterDesc': 'Para equipos pequenos que comienzan',
    'landing.professional': 'Profesional',
    'landing.professionalDesc': 'Para equipos de mantenimiento en crecimiento',
    'landing.enterprise': 'Empresa',
    'landing.enterpriseDesc': 'Para grandes organizaciones',
    'landing.upTo5': 'Hasta 5 usuarios',
    'landing.woManagement': 'Gestion de ordenes de trabajo',
    'landing.assetTracking': 'Seguimiento de activos',
    'landing.mobileAccess': 'Acceso a la app movil',
    'landing.emailNotif': 'Notificaciones por correo',
    'landing.upTo25': 'Hasta 25 usuarios',
    'landing.everythingStarter': 'Todo lo de Inicial',
    'landing.recurringScheduling': 'Programacion recurrente',
    'landing.supervisorPanel': 'Panel de supervisor',
    'landing.capacityPlanning': 'Planificacion de capacidad',
    'landing.weeklyReports': 'Informes semanales de cumplimiento',
    'landing.customBranding': 'Marca personalizada',
    'landing.unlimitedUsers': 'Usuarios ilimitados',
    'landing.everythingPro': 'Todo lo de Profesional',
    'landing.prioritySupport': 'Soporte prioritario',
    'landing.customIntegrations': 'Integraciones personalizadas',
    'landing.onPremise': 'Opcion en las instalaciones',
    'landing.sla': 'Garantia SLA',
    'landing.mobileTitle': 'Llevalo Contigo',
    'landing.mobileSubtitle': 'Descargue la app movil para acceso en movimiento. Cree ordenes de trabajo, suba fotos y reciba alertas en vivo desde el campo.',
    'landing.autoUpdate': 'Siempre descarga la ultima version — actualizacion automatica',
  },

  fr: {
    'nav.dashboard': 'Tableau de Bord',
    'nav.myWork': 'Mon Travail',
    'nav.assetLookup': 'Recherche d\'Actifs',
    'nav.workOrders': 'Ordres de Travail',
    'nav.myTeam': 'Mon Equipe',
    'nav.supervisor': 'Gestion d\'équipe',
    'nav.helpCentre': 'Centre d\'Aide',
    'nav.adminPanel': 'Panneau Admin',
    'nav.settings': 'Parametres',
    'nav.signOut': 'Deconnexion',
    'nav.projects': 'Projets',
    'nav.todos': 'A Faire',
    'nav.credentials': 'Coffre de Mots de Passe',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.delete': 'Supprimer',
    'common.edit': 'Modifier',
    'common.close': 'Fermer',
    'common.search': 'Rechercher',
    'common.loading': 'Chargement...',
    'common.noResults': 'Aucun resultat',
    'common.confirm': 'Confirmer',
    'common.back': 'Retour',
    'common.export': 'Exporter',
    'common.all': 'Tous',
    'common.allTypes': 'Tous les Types',
    'common.yes': 'Oui',
    'common.no': 'Non',
    'wo.title': 'Ordres de Travail',
    'wo.newNotification': 'Nouvelle Notification',
    'wo.newSubNotification': 'Nouvelle Sous-Notification',
    'wo.searchPlaceholder': 'Rechercher des ordres de travail...',
    'wo.noWorkOrders': 'Aucun ordre de travail trouve',
    'wo.total': '{count} ordres de travail au total',
    'wo.editWorkOrder': 'Modifier l\'Ordre de Travail',
    'wo.viewMode': 'Mode Affichage',
    'wo.shopPaper': 'Fiche d\'Atelier',
    'wo.status': 'Statut',
    'wo.priority': 'Priorite',
    'wo.type': 'Type',
    'wo.assignedTo': 'Assigne A',
    'wo.dueDate': 'Date d\'Echeance',
    'wo.createdBy': 'Cree Par',
    'wo.description': 'Description',
    'wo.operations': 'Operations',
    'wo.timeConfirmations': 'Confirmations de Temps',
    'wo.comments': 'Commentaires',
    'wo.attachments': 'Pieces Jointes',
    'wo.history': 'Historique',
    'wo.overdue': 'EN RETARD',
    'supervisor.title': 'Panneau Superviseur',
    'supervisor.notifications': 'Notifications',
    'supervisor.outstanding': 'En Cours',
    'supervisor.notConfirmed': 'Non Confirme',
    'supervisor.jobsToTeco': 'Travaux a TECO',
    'supervisor.overdueJobs': 'Travaux en Retard',
    'supervisor.capacity': 'Capacite',
    'supervisor.myTeam': 'Mon Equipe',
    'supervisor.approve': 'Approuver',
    'supervisor.reject': 'Rejeter',
    'supervisor.noPending': 'Aucune notification en attente',
    'supervisor.pendingDesc': 'Les notifications en attente d\'approbation apparaitront ici',
    'dashboard.title': 'Tableau de Bord',
    'dashboard.welcome': 'Bienvenue, {name}',
    'dashboard.openJobs': 'Travaux Ouverts',
    'dashboard.overdueJobs': 'Travaux en Retard',
    'dashboard.completedThisWeek': 'Termines Cette Semaine',
    'dashboard.dueThisWeek': 'A Faire Cette Semaine',
    'assets.title': 'Recherche d\'Actifs',
    'assets.searchPlaceholder': 'Rechercher des actifs...',
    'assets.noAssets': 'Aucun actif trouve',
    'myWork.title': 'Mon Travail',
    'myWork.noTasks': 'Aucune tache assignee',
    'teams.title': 'Mon Equipe',
    'teams.noTeams': 'Aucune equipe n\'a encore ete creee',
    'settings.title': 'Parametres',
    'settings.profile': 'Profil',
    'settings.language': 'Langue',
    'settings.theme': 'Theme',
    'settings.notifications': 'Notifications par Email',
    'help.title': 'Centre d\'Aide',
    'help.subtitle': 'Decouvrez comment fonctionne le systeme',
    'help.workflowTitle': 'Flux de Notification vers Ordre de Travail',
    'auth.signIn': 'Connexion',
    'auth.email': 'Email',
    'auth.password': 'Mot de Passe',
    'auth.forgotPassword': 'Mot de passe oublie?',
    'auth.resetPassword': 'Reinitialiser le Mot de Passe',
    'landing.getApp': 'Obtenir l\'App',
    'landing.signIn': 'Connexion',
    'landing.heroSubtitle': 'Gestion professionnelle des actifs et suivi des ordres de travail. Rationalisez la maintenance, automatisez la planification et gardez votre equipe sur la bonne voie.',
    'landing.getStarted': 'Commencer',
    'landing.downloadApp': 'Telecharger l\'App',
    'landing.featuresTitle': 'Tout ce dont vous avez besoin',
    'landing.featuresSubtitle': 'Une plateforme complete de gestion de maintenance concue pour les operations reelles.',
    'landing.feature1Title': 'Gestion des Ordres de Travail',
    'landing.feature1Desc': 'Creez, assignez et suivez les ordres de travail PM01, PM02 et PM03 avec historique complet et flux de statut.',
    'landing.feature2Title': 'Suivi des Actifs',
    'landing.feature2Desc': 'Registre complet des actifs avec profils detailles, ordres de travail lies et documents joints.',
    'landing.feature3Title': 'Planification Recurrente',
    'landing.feature3Desc': 'Automatisez la maintenance recurrente PM02 avec des frequences flexibles du quotidien a l\'annuel.',
    'landing.feature4Title': 'Equipe et Panneau Superviseur',
    'landing.feature4Desc': 'Gerez les equipes avec des permissions par groupe, supervision, planification de capacite et suivi de conformite.',
    'landing.feature5Title': 'Gestion Documentaire',
    'landing.feature5Desc': 'Telechargez images, videos et documents sur les ordres de travail et actifs avec apercu.',
    'landing.feature6Title': 'Tableau de Bord et Analytique',
    'landing.feature6Desc': 'Vue d\'ensemble en temps reel avec graphiques, statistiques, alertes de retard et visualisation de charge.',
    'landing.feature7Title': 'Confirmations de Temps',
    'landing.feature7Desc': 'Enregistrez les heures contre les ordres de travail avec suivi du temps et approbations TECO.',
    'landing.feature8Title': 'Notifications par Email',
    'landing.feature8Desc': 'Resumes automatiques quotidiens/hebdomadaires, alertes d\'assignation et rappels d\'echeance.',
    'landing.feature9Title': 'Acces Base sur les Roles',
    'landing.feature9Desc': 'Roles Admin, Superviseur et Utilisateur avec permissions KPT et acces par groupe.',
    'landing.feature10Title': 'Application Mobile',
    'landing.feature10Desc': 'Applications natives Android et iOS avec notifications push pour l\'acces terrain.',
    'landing.feature11Title': 'Planification de Capacite',
    'landing.feature11Desc': 'Graphiques d\'utilisation d\'equipe, configuration des heures de travail et equilibrage de charge.',
    'landing.feature12Title': 'Planification et Modeles',
    'landing.feature12Desc': 'Modeles d\'ordres de travail, sous-ordres, calendrier de charge et generation recurrente automatique.',
    'landing.woTypesTitle': 'Trois Types d\'Ordres de Travail',
    'landing.woTypesSubtitle': 'Couvrez chaque scenario de maintenance avec des classifications d\'ordres de travail specifiques.',
    'landing.pm01Label': 'Planifie',
    'landing.pm01Desc': 'Taches de maintenance planifiees avec dates d\'echeance et equilibrage de charge.',
    'landing.pm02Label': 'Recurrent',
    'landing.pm02Desc': 'Travaux recurrents automatises avec frequences configurables.',
    'landing.pm03Label': 'Non Planifie',
    'landing.pm03Desc': 'Ordres de travail reactifs pour pannes et problemes urgents.',
    'landing.workflowTitle': 'Flux d\'Approbation Simple',
    'landing.workflowSubtitle': 'De la notification a l\'ordre de travail en quelques clics. Chaque travail passe par un processus d\'approbation clair.',
    'landing.step1Title': 'Notification Creee',
    'landing.step1Desc': 'L\'utilisateur soumet une notification decrivant le travail necessaire',
    'landing.step2Title': 'Revision du Superviseur',
    'landing.step2Sub': 'Panneau Superviseur',
    'landing.step2Desc': 'Apparait dans l\'onglet Notifications pour revision',
    'landing.step3Title': 'Approuve',
    'landing.step3Sub': 'Approbation en un clic',
    'landing.step3Desc': 'Le superviseur approuve et la notification se convertit automatiquement',
    'landing.step4Title': 'Ordre de Travail Actif',
    'landing.step4Desc': 'Ordre de travail complet cree avec operations et planification',
    'landing.highlightsTitle': 'Concu pour les Equipes',
    'landing.highlightsSubtitle': 'Des techniciens individuels aux departements de maintenance complets.',
    'landing.highlight1': 'Numeros d\'ordre de travail uniques a 9 chiffres pour chaque travail',
    'landing.highlight2': 'Historique d\'audit complet suivant chaque modification',
    'landing.highlight3': 'Panneau Mon Travail affichant vos taches assignees et en retard',
    'landing.highlight4': 'Panneau admin pour la gestion des utilisateurs, actifs, fournisseurs et sites',
    'landing.highlight5': 'Pieces jointes images, videos et documents avec apercu',
    'landing.highlight6': 'Graphique de charge aide a equilibrer le travail entre les dates',
    'landing.highlight7': 'Niveaux de priorite avec indicateurs visuels colores',
    'landing.highlight8': 'Design responsive mobile fonctionne sur tout appareil',
    'landing.highlight9': 'Panneau superviseur avec supervision d\'equipe et approbations',
    'landing.highlight10': 'Rapports de conformite hebdomadaires envoyes aux administrateurs',
    'landing.highlight11': 'Mode sombre avec preferences de theme par utilisateur',
    'landing.highlight12': 'Marque personnalisee du site avec logo et favicon',
    'landing.pricingTitle': 'Tarification Simple',
    'landing.pricingSubtitle': 'Plans clairs en AUD. Pas de frais caches.',
    'landing.mostPopular': 'Le Plus Populaire',
    'landing.starter': 'Debutant',
    'landing.starterDesc': 'Pour les petites equipes qui demarrent',
    'landing.professional': 'Professionnel',
    'landing.professionalDesc': 'Pour les equipes de maintenance en croissance',
    'landing.enterprise': 'Entreprise',
    'landing.enterpriseDesc': 'Pour les grandes organisations',
    'landing.mobileTitle': 'Emportez-le Partout',
    'landing.mobileSubtitle': 'Telechargez l\'application mobile pour un acces en deplacement. Creez des ordres de travail, telechargez des photos et recevez des alertes en direct depuis le terrain.',
    'landing.autoUpdate': 'Telecharge toujours la derniere version — mise a jour automatique',
  },

  de: {
    'nav.dashboard': 'Dashboard',
    'nav.myWork': 'Meine Arbeit',
    'nav.assetLookup': 'Anlagensuche',
    'nav.workOrders': 'Arbeitsauftrage',
    'nav.myTeam': 'Mein Team',
    'nav.supervisor': 'Teamleitung',
    'nav.helpCentre': 'Hilfezentrum',
    'nav.adminPanel': 'Admin-Bereich',
    'nav.settings': 'Einstellungen',
    'nav.signOut': 'Abmelden',
    'nav.projects': 'Projekte',
    'nav.todos': 'Aufgaben',
    'nav.credentials': 'Passwort-Tresor',
    'common.save': 'Speichern',
    'common.cancel': 'Abbrechen',
    'common.delete': 'Loschen',
    'common.edit': 'Bearbeiten',
    'common.close': 'Schliessen',
    'common.search': 'Suchen',
    'common.loading': 'Laden...',
    'common.noResults': 'Keine Ergebnisse',
    'common.confirm': 'Bestatigen',
    'common.back': 'Zuruck',
    'common.export': 'Exportieren',
    'common.all': 'Alle',
    'common.allTypes': 'Alle Typen',
    'common.yes': 'Ja',
    'common.no': 'Nein',
    'wo.title': 'Arbeitsauftrage',
    'wo.newNotification': 'Neue Meldung',
    'wo.newSubNotification': 'Neue Untermeldung',
    'wo.searchPlaceholder': 'Arbeitsauftrage suchen...',
    'wo.noWorkOrders': 'Keine Arbeitsauftrage gefunden',
    'wo.total': '{count} Arbeitsauftrage insgesamt',
    'wo.editWorkOrder': 'Arbeitsauftrag Bearbeiten',
    'wo.viewMode': 'Ansichtsmodus',
    'wo.shopPaper': 'Werkstattschein',
    'wo.status': 'Status',
    'wo.priority': 'Prioritat',
    'wo.type': 'Typ',
    'wo.assignedTo': 'Zugewiesen An',
    'wo.dueDate': 'Falligkeitsdatum',
    'wo.createdBy': 'Erstellt Von',
    'wo.description': 'Beschreibung',
    'wo.operations': 'Vorgange',
    'wo.timeConfirmations': 'Zeitruckmeldungen',
    'wo.comments': 'Kommentare',
    'wo.attachments': 'Anhange',
    'wo.history': 'Verlauf',
    'wo.overdue': 'UBERFÄLLIG',
    'supervisor.title': 'Vorgesetzten-Panel',
    'supervisor.notifications': 'Meldungen',
    'supervisor.outstanding': 'Ausstehend',
    'supervisor.notConfirmed': 'Nicht Bestatigt',
    'supervisor.jobsToTeco': 'Auftrage fur TECO',
    'supervisor.overdueJobs': 'Uberfallige Auftrage',
    'supervisor.capacity': 'Kapazitat',
    'supervisor.myTeam': 'Mein Team',
    'supervisor.approve': 'Genehmigen',
    'supervisor.reject': 'Ablehnen',
    'supervisor.noPending': 'Keine offenen Meldungen',
    'supervisor.pendingDesc': 'Meldungen zur Genehmigung erscheinen hier',
    'dashboard.title': 'Dashboard',
    'dashboard.welcome': 'Willkommen zuruck, {name}',
    'dashboard.openJobs': 'Offene Auftrage',
    'dashboard.overdueJobs': 'Uberfallige Auftrage',
    'dashboard.completedThisWeek': 'Diese Woche Abgeschlossen',
    'dashboard.dueThisWeek': 'Diese Woche Fallig',
    'assets.title': 'Anlagensuche',
    'assets.searchPlaceholder': 'Anlagen suchen...',
    'assets.noAssets': 'Keine Anlagen gefunden',
    'myWork.title': 'Meine Arbeit',
    'myWork.noTasks': 'Keine Aufgaben zugewiesen',
    'teams.title': 'Mein Team',
    'teams.noTeams': 'Noch keine Teams erstellt',
    'settings.title': 'Einstellungen',
    'settings.profile': 'Profil',
    'settings.language': 'Sprache',
    'settings.theme': 'Design',
    'settings.notifications': 'E-Mail-Benachrichtigungen',
    'help.title': 'Hilfezentrum',
    'help.subtitle': 'Erfahren Sie, wie das System funktioniert',
    'help.workflowTitle': 'Workflow: Meldung zum Arbeitsauftrag',
    'auth.signIn': 'Anmelden',
    'auth.email': 'E-Mail',
    'auth.password': 'Passwort',
    'auth.forgotPassword': 'Passwort vergessen?',
    'auth.resetPassword': 'Passwort Zurucksetzen',
    'landing.getApp': 'App Holen',
    'landing.signIn': 'Anmelden',
    'landing.heroSubtitle': 'Professionelles Anlagenmanagement und Arbeitsauftragsverfolgung. Optimieren Sie die Wartung, automatisieren Sie die Planung und halten Sie Ihr Team auf Kurs.',
    'landing.getStarted': 'Loslegen',
    'landing.downloadApp': 'App Herunterladen',
    'landing.featuresTitle': 'Alles was Sie brauchen',
    'landing.featuresSubtitle': 'Eine komplette Wartungsmanagement-Plattform fur den realen Betrieb.',
    'landing.feature1Title': 'Auftragsverwaltung',
    'landing.feature1Desc': 'Erstellen, zuweisen und verfolgen Sie PM01, PM02 und PM03 Arbeitsauftrage mit vollstandigem Verlauf.',
    'landing.feature2Title': 'Anlagenverfolgung',
    'landing.feature2Desc': 'Umfassendes Anlagenregister mit detaillierten Profilen, verknupften Auftragen und Dokumenten.',
    'landing.feature3Title': 'Wiederkehrende Planung',
    'landing.feature3Desc': 'Automatisieren Sie wiederkehrende PM02-Wartung mit flexiblen Frequenzen von taglich bis jahrlich.',
    'landing.feature4Title': 'Team- und Vorgesetzten-Panel',
    'landing.feature4Desc': 'Verwalten Sie Teams mit gruppenbasierten Berechtigungen, Aufsicht, Kapazitatsplanung und Compliance-Tracking.',
    'landing.feature5Title': 'Dokumentenverwaltung',
    'landing.feature5Desc': 'Laden Sie Bilder, Videos und Dokumente zu Auftragen und Anlagen mit Vorschau hoch.',
    'landing.feature6Title': 'Dashboard und Analytik',
    'landing.feature6Desc': 'Echtzeit-Ubersicht mit Diagrammen, Statistiken, Uberfälligkeitsalarmen und Lastvisualisierung.',
    'landing.feature7Title': 'Zeitruckmeldungen',
    'landing.feature7Desc': 'Erfassen Sie Stunden gegen Arbeitsauftrage mit Zeiterfassung und TECO-Genehmigungen.',
    'landing.feature8Title': 'E-Mail-Benachrichtigungen',
    'landing.feature8Desc': 'Automatische tagliche/wochentliche Zusammenfassungen, Zuweisungsalarme und Falligkeitserinnerungen.',
    'landing.feature9Title': 'Rollenbasierter Zugang',
    'landing.feature9Desc': 'Admin-, Vorgesetzten- und Benutzerrollen mit KPT-Berechtigungen und gruppenbasiertem Zugang.',
    'landing.feature10Title': 'Mobile App',
    'landing.feature10Desc': 'Native Android- und iOS-Apps mit Push-Benachrichtigungen fur den Feldzugang.',
    'landing.feature11Title': 'Kapazitatsplanung',
    'landing.feature11Desc': 'Auslastungsdiagramme, Arbeitszeitkonfiguration und Lastausgleich.',
    'landing.feature12Title': 'Planung und Vorlagen',
    'landing.feature12Desc': 'Auftragsvorlagen, Unterauftrage, Lastkalender und automatische wiederkehrende Generierung.',
    'landing.woTypesTitle': 'Drei Auftragstypen',
    'landing.woTypesSubtitle': 'Decken Sie jedes Wartungsszenario mit spezifischen Auftragsklassifikationen ab.',
    'landing.pm01Label': 'Geplant',
    'landing.pm01Desc': 'Geplante Wartungsaufgaben mit Falligkeitsdaten und Lastausgleich.',
    'landing.pm02Label': 'Wiederkehrend',
    'landing.pm02Desc': 'Automatisierte wiederkehrende Auftrage mit konfigurierbaren Frequenzen.',
    'landing.pm03Label': 'Ungeplant',
    'landing.pm03Desc': 'Reaktive Arbeitsauftrage fur Ausfalle und dringende Probleme.',
    'landing.workflowTitle': 'Einfacher Genehmigungsablauf',
    'landing.workflowSubtitle': 'Von der Meldung zum Arbeitsauftrag in wenigen Klicks. Jeder Auftrag durchlauft einen klaren Genehmigungsprozess.',
    'landing.step1Title': 'Meldung Erstellt',
    'landing.step1Desc': 'Benutzer reicht eine Meldung ein, die die benotigte Arbeit beschreibt',
    'landing.step2Title': 'Vorgesetzter Pruft',
    'landing.step2Sub': 'Vorgesetzten-Panel',
    'landing.step2Desc': 'Erscheint im Meldungen-Tab zur Prufung',
    'landing.step3Title': 'Genehmigt',
    'landing.step3Sub': 'Ein-Klick-Genehmigung',
    'landing.step3Desc': 'Vorgesetzter genehmigt und die Meldung wird automatisch konvertiert',
    'landing.step4Title': 'Arbeitsauftrag Aktiv',
    'landing.step4Desc': 'Vollstandiger Arbeitsauftrag erstellt mit Vorgangen und Planung',
    'landing.highlightsTitle': 'Fur Teams Gebaut',
    'landing.highlightsSubtitle': 'Von Einzeltechnikern bis zu kompletten Wartungsabteilungen.',
    'landing.highlight1': 'Eindeutige 9-stellige Auftragsnummern fur jeden Auftrag',
    'landing.highlight2': 'Vollstandiger Audit-Verlauf jeder Feldanderung',
    'landing.highlight3': 'Mein-Arbeit-Panel zeigt zugewiesene und uberfallige Aufgaben',
    'landing.highlight4': 'Admin-Panel fur Benutzer-, Anlagen-, Lieferanten- und Standortverwaltung',
    'landing.highlight5': 'Bild-, Video- und Dokumentanhange mit Vorschau',
    'landing.highlight6': 'Lastgraph hilft Arbeit uber Termine auszugleichen',
    'landing.highlight7': 'Prioritatsstufen mit farbcodierten visuellen Indikatoren',
    'landing.highlight8': 'Mobil-responsives Design funktioniert auf jedem Gerat',
    'landing.highlight9': 'Vorgesetzten-Panel mit Teamaufsicht und Genehmigungen',
    'landing.highlight10': 'Wochentliche Compliance-Berichte an Administratoren',
    'landing.highlight11': 'Dunkelmodus mit benutzerspezifischen Theme-Einstellungen',
    'landing.highlight12': 'Individuelle Seitengestaltung mit Logo und Favicon',
    'landing.pricingTitle': 'Einfache Preisgestaltung',
    'landing.pricingSubtitle': 'Klare Plane in AUD. Keine versteckten Gebuhren.',
    'landing.mostPopular': 'Am Beliebtesten',
    'landing.starter': 'Starter',
    'landing.starterDesc': 'Fur kleine Teams zum Einstieg',
    'landing.professional': 'Professionell',
    'landing.professionalDesc': 'Fur wachsende Wartungsteams',
    'landing.enterprise': 'Unternehmen',
    'landing.enterpriseDesc': 'Fur grosse Organisationen',
    'landing.mobileTitle': 'Nehmen Sie es mit',
    'landing.mobileSubtitle': 'Laden Sie die mobile App fur den Zugang unterwegs herunter. Erstellen Sie Auftrage, laden Sie Fotos hoch und erhalten Sie Live-Alarme vom Feld.',
    'landing.autoUpdate': 'Ladt immer die neueste Version herunter — automatische Aktualisierung',
  },

  zh: {
    'nav.dashboard': '仪表板',
    'nav.myWork': '我的工作',
    'nav.assetLookup': '资产查询',
    'nav.workOrders': '工单',
    'nav.myTeam': '我的团队',
    'nav.supervisor': '团队管理',
    'nav.helpCentre': '帮助中心',
    'nav.adminPanel': '管理面板',
    'nav.settings': '设置',
    'nav.signOut': '退出登录',
    'nav.projects': '项目',
    'nav.todos': '待办',
    'nav.credentials': '凭证库',
    'common.save': '保存',
    'common.cancel': '取消',
    'common.delete': '删除',
    'common.edit': '编辑',
    'common.close': '关闭',
    'common.search': '搜索',
    'common.loading': '加载中...',
    'common.noResults': '未找到结果',
    'common.confirm': '确认',
    'common.back': '返回',
    'common.export': '导出',
    'common.all': '全部',
    'common.allTypes': '所有类型',
    'common.yes': '是',
    'common.no': '否',
    'wo.title': '工单',
    'wo.newNotification': '新通知',
    'wo.newSubNotification': '新子通知',
    'wo.searchPlaceholder': '搜索工单...',
    'wo.noWorkOrders': '未找到工单',
    'wo.total': '共{count}个工单',
    'wo.editWorkOrder': '编辑工单',
    'wo.viewMode': '查看模式',
    'wo.shopPaper': '车间工单',
    'wo.status': '状态',
    'wo.priority': '优先级',
    'wo.type': '类型',
    'wo.assignedTo': '分配给',
    'wo.dueDate': '截止日期',
    'wo.createdBy': '创建者',
    'wo.description': '描述',
    'wo.operations': '工序',
    'wo.timeConfirmations': '工时确认',
    'wo.comments': '评论',
    'wo.attachments': '附件',
    'wo.history': '历史',
    'wo.overdue': '逾期',
    'supervisor.title': '主管面板',
    'supervisor.notifications': '通知',
    'supervisor.outstanding': '待处理',
    'supervisor.notConfirmed': '未确认',
    'supervisor.jobsToTeco': '待TECO',
    'supervisor.overdueJobs': '逾期工单',
    'supervisor.capacity': '产能',
    'supervisor.myTeam': '我的团队',
    'supervisor.approve': '批准',
    'supervisor.reject': '拒绝',
    'supervisor.noPending': '无待处理通知',
    'supervisor.pendingDesc': '待批准的通知将显示在此处',
    'dashboard.title': '仪表板',
    'dashboard.welcome': '欢迎回来，{name}',
    'dashboard.openJobs': '未完成工单',
    'dashboard.overdueJobs': '逾期工单',
    'dashboard.completedThisWeek': '本周已完成',
    'dashboard.dueThisWeek': '本周到期',
    'assets.title': '资产查询',
    'assets.searchPlaceholder': '搜索资产...',
    'assets.noAssets': '未找到资产',
    'myWork.title': '我的工作',
    'myWork.noTasks': '无分配任务',
    'teams.title': '我的团队',
    'teams.noTeams': '尚未创建团队',
    'settings.title': '设置',
    'settings.profile': '个人资料',
    'settings.language': '语言',
    'settings.theme': '主题',
    'settings.notifications': '邮件通知',
    'help.title': '帮助中心',
    'help.subtitle': '了解系统如何运作',
    'help.workflowTitle': '通知到工单的工作流程',
    'auth.signIn': '登录',
    'auth.email': '邮箱',
    'auth.password': '密码',
    'auth.forgotPassword': '忘记密码？',
    'auth.resetPassword': '重置密码',
    'landing.getApp': '获取应用',
    'landing.signIn': '登录',
    'landing.heroSubtitle': '专业的资产管理和工单跟踪。简化维护，自动化调度，让您的团队保持高效。',
    'landing.getStarted': '开始使用',
    'landing.downloadApp': '下载应用',
    'landing.featuresTitle': '您所需的一切',
    'landing.featuresSubtitle': '为实际运营打造的完整维护管理平台。',
    'landing.feature1Title': '工单管理',
    'landing.feature1Desc': '创建、分配和跟踪PM01、PM02和PM03工单，包含完整历史和状态流程。',
    'landing.feature2Title': '资产跟踪',
    'landing.feature2Desc': '全面的资产登记，包含详细档案、关联工单和文档附件。',
    'landing.feature3Title': '周期性计划',
    'landing.feature3Desc': '通过灵活的频率（从每日到每年）自动化PM02周期性维护。',
    'landing.feature4Title': '团队与主管面板',
    'landing.feature4Desc': '通过基于组的权限、主管监督、产能规划和合规跟踪管理团队。',
    'landing.feature5Title': '文档管理',
    'landing.feature5Desc': '向工单和资产上传图片、视频和文档，支持预览。',
    'landing.feature6Title': '仪表板与分析',
    'landing.feature6Desc': '实时概览，包含图表、统计、逾期警报和工作量可视化。',
    'landing.feature7Title': '工时确认',
    'landing.feature7Desc': '对工单记录工时，支持时间跟踪、完工流程和TECO审批。',
    'landing.feature8Title': '邮件通知',
    'landing.feature8Desc': '自动每日/每周摘要、分配提醒、到期提醒和合规报告。',
    'landing.feature9Title': '基于角色的访问',
    'landing.feature9Desc': '管理员、主管和用户角色，支持KPT权限和基于组的访问。',
    'landing.feature10Title': '移动应用',
    'landing.feature10Desc': '原生Android和iOS应用，支持推送通知，随时随地现场访问。',
    'landing.feature11Title': '产能规划',
    'landing.feature11Desc': '团队利用率图表、工作时间配置和工作量平衡。',
    'landing.feature12Title': '计划与模板',
    'landing.feature12Desc': '工单模板、子工单、工作量日历和自动周期性生成。',
    'landing.woTypesTitle': '三种工单类型',
    'landing.woTypesSubtitle': '通过专用工单分类覆盖每种维护场景。',
    'landing.pm01Label': '计划性',
    'landing.pm01Desc': '带有截止日期和工作量平衡的计划维护任务。',
    'landing.pm02Label': '周期性',
    'landing.pm02Desc': '具有可配置频率的自动化周期性作业。',
    'landing.pm03Label': '非计划性',
    'landing.pm03Desc': '用于故障和紧急问题的响应式工单。',
    'landing.workflowTitle': '简单审批流程',
    'landing.workflowSubtitle': '从通知到工单只需几次点击。每项工作都经过清晰的审批流程。',
    'landing.step1Title': '创建通知',
    'landing.step1Desc': '用户提交描述所需工作的通知',
    'landing.step2Title': '主管审核',
    'landing.step2Sub': '主管面板',
    'landing.step2Desc': '出现在通知标签页中等待审核',
    'landing.step3Title': '已批准',
    'landing.step3Sub': '一键审批',
    'landing.step3Desc': '主管批准后通知自动转换',
    'landing.step4Title': '工单生效',
    'landing.step4Desc': '创建包含工序和计划的完整工单',
    'landing.highlightsTitle': '为团队而建',
    'landing.highlightsSubtitle': '从个人技术员到完整的维护部门。',
    'landing.highlight1': '每项工作都有唯一的9位工单编号',
    'landing.highlight2': '完整的审计历史追踪每个字段变更',
    'landing.highlight3': '我的工作面板显示您的已分配和逾期任务',
    'landing.highlight4': '管理面板用于用户、资产、供应商和地点管理',
    'landing.highlight5': '图片、视频和文档附件支持预览',
    'landing.highlight6': '工作量图表帮助平衡跨日期的工作',
    'landing.highlight7': '带有彩色视觉指示器的优先级级别',
    'landing.highlight8': '移动响应式设计适用于任何设备',
    'landing.highlight9': '主管面板支持团队监督和审批',
    'landing.highlight10': '每周合规报告发送给管理员',
    'landing.highlight11': '暗色模式支持按用户的主题偏好',
    'landing.highlight12': '自定义网站品牌，支持Logo和图标',
    'landing.pricingTitle': '简单定价',
    'landing.pricingSubtitle': '以澳元计价的清晰方案。无隐藏费用。',
    'landing.mostPopular': '最受欢迎',
    'landing.starter': '入门版',
    'landing.starterDesc': '适合刚起步的小团队',
    'landing.professional': '专业版',
    'landing.professionalDesc': '适合成长中的维护团队',
    'landing.enterprise': '企业版',
    'landing.enterpriseDesc': '适合大型组织',
    'landing.mobileTitle': '随身携带',
    'landing.mobileSubtitle': '下载移动应用随时随地访问。创建工单、上传照片，从现场获取实时警报。',
    'landing.autoUpdate': '始终下载最新版本 — 强制自动更新',
  },

  ja: {
    'nav.dashboard': 'ダッシュボード',
    'nav.myWork': 'マイワーク',
    'nav.assetLookup': '資産検索',
    'nav.workOrders': '作業指示',
    'nav.myTeam': 'マイチーム',
    'nav.supervisor': 'チーム管理',
    'nav.helpCentre': 'ヘルプセンター',
    'nav.adminPanel': '管理パネル',
    'nav.settings': '設定',
    'nav.signOut': 'ログアウト',
    'nav.projects': 'プロジェクト',
    'nav.todos': 'やること',
    'nav.credentials': '認証情報',
    'common.save': '保存',
    'common.cancel': 'キャンセル',
    'common.delete': '削除',
    'common.edit': '編集',
    'common.close': '閉じる',
    'common.search': '検索',
    'common.loading': '読み込み中...',
    'common.noResults': '結果が見つかりません',
    'common.confirm': '確認',
    'common.back': '戻る',
    'common.export': 'エクスポート',
    'common.all': 'すべて',
    'common.allTypes': 'すべてのタイプ',
    'common.yes': 'はい',
    'common.no': 'いいえ',
    'wo.title': '作業指示',
    'wo.newNotification': '新規通知',
    'wo.searchPlaceholder': '作業指示を検索...',
    'wo.noWorkOrders': '作業指示が見つかりません',
    'wo.shopPaper': '作業票',
    'supervisor.title': '管理者パネル',
    'supervisor.approve': '承認',
    'supervisor.reject': '却下',
    'settings.title': '設定',
    'settings.language': '言語',
    'auth.signIn': 'ログイン',
    'landing.getApp': 'アプリ取得',
    'landing.signIn': 'ログイン',
    'landing.heroSubtitle': 'プロフェッショナルな資産管理と作業指示追跡。メンテナンスを効率化し、スケジュールを自動化し、チームを軌道に乗せましょう。',
    'landing.getStarted': '始める',
    'landing.downloadApp': 'アプリダウンロード',
    'landing.featuresTitle': '必要なすべてが揃っています',
    'landing.featuresSubtitle': '実際の運用に向けて構築された完全なメンテナンス管理プラットフォーム。',
    'landing.feature1Title': '作業指示管理',
    'landing.feature1Desc': 'PM01、PM02、PM03の作業指示を作成、割当、追跡。完全な履歴とステータスワークフロー付き。',
    'landing.feature2Title': '資産追跡',
    'landing.feature2Desc': '詳細プロファイル、リンクされた作業指示、ドキュメント添付を備えた包括的な資産レジストリ。',
    'landing.feature3Title': '定期スケジュール',
    'landing.feature3Desc': '日次から年次まで柔軟な頻度でPM02定期メンテナンスを自動化。',
    'landing.feature4Title': 'チーム・管理者パネル',
    'landing.feature4Desc': 'グループベースの権限、管理者監督、キャパシティプランニング、コンプライアンス追跡でチームを管理。',
    'landing.feature5Title': 'ドキュメント管理',
    'landing.feature5Desc': '作業指示と資産に画像、動画、ドキュメントをアップロード。プレビュー付き。',
    'landing.feature6Title': 'ダッシュボードと分析',
    'landing.feature6Desc': 'チャート、統計、期限超過アラート、作業負荷の可視化によるリアルタイム概要。',
    'landing.feature7Title': '時間確認',
    'landing.feature7Desc': '作業指示に対する時間記録、完了ワークフロー、TECO承認。',
    'landing.feature8Title': 'メール通知',
    'landing.feature8Desc': '自動の日次/週次サマリー、割当アラート、期限リマインダー、コンプライアンスレポート。',
    'landing.feature9Title': 'ロールベースアクセス',
    'landing.feature9Desc': '管理者、監督者、ユーザーロール。KPT権限とグループベースのアクセス。',
    'landing.feature10Title': 'モバイルアプリ',
    'landing.feature10Desc': 'プッシュ通知対応のネイティブAndroid・iOSアプリ。フィールドからのアクセス。',
    'landing.feature11Title': 'キャパシティプランニング',
    'landing.feature11Desc': 'チーム稼働率チャート、労働時間設定、ワークロードバランシング。',
    'landing.feature12Title': 'スケジュールとテンプレート',
    'landing.feature12Desc': '作業指示テンプレート、サブ作業指示、作業負荷カレンダー、自動定期生成。',
    'landing.woTypesTitle': '3つの作業指示タイプ',
    'landing.woTypesSubtitle': '専用の作業指示分類であらゆるメンテナンスシナリオに対応。',
    'landing.pm01Label': '計画',
    'landing.pm01Desc': '期日と作業負荷バランスを持つ計画的メンテナンスタスク。',
    'landing.pm02Label': '定期',
    'landing.pm02Desc': '設定可能な頻度の自動化された定期ジョブ。',
    'landing.pm03Label': '非計画',
    'landing.pm03Desc': '故障や緊急問題に対応するリアクティブな作業指示。',
    'landing.workflowTitle': 'シンプルな承認ワークフロー',
    'landing.workflowSubtitle': '通知から作業指示まで数クリック。すべての作業が明確な承認プロセスを経ます。',
    'landing.step1Title': '通知作成',
    'landing.step1Desc': 'ユーザーが必要な作業を説明する通知を提出',
    'landing.step2Title': '管理者レビュー',
    'landing.step2Sub': '管理者パネル',
    'landing.step2Desc': '通知タブに表示されレビューを待つ',
    'landing.step3Title': '承認済み',
    'landing.step3Sub': 'ワンクリック承認',
    'landing.step3Desc': '管理者が承認すると通知が自動的に変換',
    'landing.step4Title': '作業指示稼働',
    'landing.step4Desc': '工程とスケジュールを含む完全な作業指示が作成',
    'landing.highlightsTitle': 'チームのために構築',
    'landing.highlightsSubtitle': '個人の技術者から完全なメンテナンス部門まで。',
    'landing.pricingTitle': 'シンプルな料金',
    'landing.pricingSubtitle': 'AUDでの明確なプラン。隠れた料金はありません。',
    'landing.mostPopular': '最も人気',
    'landing.starter': 'スターター',
    'landing.starterDesc': '始めたばかりの小さなチーム向け',
    'landing.professional': 'プロフェッショナル',
    'landing.professionalDesc': '成長中のメンテナンスチーム向け',
    'landing.enterprise': 'エンタープライズ',
    'landing.enterpriseDesc': '大規模組織向け',
    'landing.mobileTitle': '持ち歩こう',
    'landing.mobileSubtitle': '移動中のアクセスにモバイルアプリをダウンロード。作業指示の作成、写真のアップロード、現場からのリアルタイムアラート。',
    'landing.autoUpdate': '常に最新バージョンをダウンロード — 自動更新',
  },

  ar: {
    'nav.dashboard': 'لوحة التحكم',
    'nav.myWork': 'عملي',
    'nav.assetLookup': 'البحث عن الأصول',
    'nav.workOrders': 'أوامر العمل',
    'nav.myTeam': 'فريقي',
    'nav.supervisor': 'إدارة الفريق',
    'nav.helpCentre': 'مركز المساعدة',
    'nav.adminPanel': 'لوحة الإدارة',
    'nav.settings': 'الإعدادات',
    'nav.signOut': 'تسجيل الخروج',
    'nav.projects': 'المشاريع',
    'nav.todos': 'المهام',
    'nav.credentials': 'خزنة بيانات الاعتماد',
    'common.save': 'حفظ',
    'common.cancel': 'إلغاء',
    'common.delete': 'حذف',
    'common.edit': 'تعديل',
    'common.close': 'إغلاق',
    'common.search': 'بحث',
    'common.loading': 'جاري التحميل...',
    'wo.title': 'أوامر العمل',
    'wo.newNotification': 'إشعار جديد',
    'wo.shopPaper': 'ورقة العمل',
    'supervisor.approve': 'موافقة',
    'supervisor.reject': 'رفض',
    'settings.title': 'الإعدادات',
    'settings.language': 'اللغة',
    'auth.signIn': 'تسجيل الدخول',
    'landing.getApp': 'احصل على التطبيق',
    'landing.signIn': 'تسجيل الدخول',
    'landing.heroSubtitle': 'إدارة احترافية للأصول وتتبع أوامر العمل. تبسيط الصيانة وأتمتة الجدولة وإبقاء فريقك على المسار.',
    'landing.getStarted': 'ابدأ الآن',
    'landing.downloadApp': 'تحميل التطبيق',
    'landing.featuresTitle': 'كل ما تحتاجه',
    'landing.featuresSubtitle': 'منصة إدارة صيانة كاملة مصممة للعمليات الواقعية.',
    'landing.feature1Title': 'إدارة أوامر العمل',
    'landing.feature2Title': 'تتبع الأصول',
    'landing.feature3Title': 'جدولة دورية',
    'landing.feature4Title': 'الفريق ولوحة المشرف',
    'landing.feature5Title': 'إدارة المستندات',
    'landing.feature6Title': 'لوحة التحكم والتحليلات',
    'landing.feature7Title': 'تأكيدات الوقت',
    'landing.feature8Title': 'إشعارات البريد الإلكتروني',
    'landing.feature9Title': 'الوصول حسب الأدوار',
    'landing.feature10Title': 'تطبيق الجوال',
    'landing.feature11Title': 'تخطيط القدرات',
    'landing.feature12Title': 'الجدولة والقوالب',
    'landing.woTypesTitle': 'ثلاثة أنواع لأوامر العمل',
    'landing.workflowTitle': 'سير عمل الموافقة البسيط',
    'landing.highlightsTitle': 'مصمم للفرق',
    'landing.pricingTitle': 'تسعير بسيط',
    'landing.mobileTitle': 'خذه معك',
    'landing.autoUpdate': 'يقوم دائماً بتنزيل أحدث إصدار — تحديث تلقائي',
  },

  hi: {
    'nav.dashboard': 'डैशबोर्ड',
    'nav.myWork': 'मेरा काम',
    'nav.assetLookup': 'संपत्ति खोज',
    'nav.workOrders': 'कार्य आदेश',
    'nav.myTeam': 'मेरी टीम',
    'nav.supervisor': 'टीम प्रबंधक',
    'nav.helpCentre': 'सहायता केंद्र',
    'nav.settings': 'सेटिंग्स',
    'nav.signOut': 'लॉग आउट',
    'nav.projects': 'परियोजनाएँ',
    'nav.todos': 'कार्य सूची',
    'nav.credentials': 'क्रेडेंशियल वॉल्ट',
    'common.save': 'सहेजें',
    'common.cancel': 'रद्द करें',
    'wo.title': 'कार्य आदेश',
    'wo.newNotification': 'नई सूचना',
    'wo.shopPaper': 'शॉप पेपर',
    'supervisor.approve': 'स्वीकृत करें',
    'supervisor.reject': 'अस्वीकार करें',
    'settings.title': 'सेटिंग्स',
    'settings.language': 'भाषा',
    'auth.signIn': 'साइन इन',
    'landing.getApp': 'ऐप प्राप्त करें',
    'landing.signIn': 'साइन इन',
    'landing.heroSubtitle': 'पेशेवर संपत्ति प्रबंधन और कार्य आदेश ट्रैकिंग। रखरखाव को सुव्यवस्थित करें, शेड्यूलिंग को स्वचालित करें।',
    'landing.getStarted': 'शुरू करें',
    'landing.downloadApp': 'ऐप डाउनलोड करें',
    'landing.featuresTitle': 'आपको जो कुछ भी चाहिए',
    'landing.featuresSubtitle': 'वास्तविक संचालन के लिए बनाया गया एक पूर्ण रखरखाव प्रबंधन मंच।',
    'landing.feature1Title': 'कार्य आदेश प्रबंधन',
    'landing.feature2Title': 'संपत्ति ट्रैकिंग',
    'landing.feature3Title': 'आवर्ती शेड्यूलिंग',
    'landing.feature4Title': 'टीम और पर्यवेक्षक पैनल',
    'landing.feature5Title': 'दस्तावेज़ प्रबंधन',
    'landing.feature6Title': 'डैशबोर्ड और विश्लेषण',
    'landing.feature7Title': 'समय पुष्टिकरण',
    'landing.feature8Title': 'ईमेल सूचनाएं',
    'landing.feature9Title': 'भूमिका-आधारित पहुंच',
    'landing.feature10Title': 'मोबाइल ऐप',
    'landing.feature11Title': 'क्षमता योजना',
    'landing.feature12Title': 'शेड्यूलिंग और टेम्पलेट',
    'landing.woTypesTitle': 'तीन कार्य आदेश प्रकार',
    'landing.workflowTitle': 'सरल अनुमोदन कार्यप्रवाह',
    'landing.highlightsTitle': 'टीमों के लिए बनाया गया',
    'landing.pricingTitle': 'सरल मूल्य निर्धारण',
    'landing.mobileTitle': 'इसे अपने साथ ले जाएं',
    'landing.autoUpdate': 'हमेशा नवीनतम संस्करण डाउनलोड करता है — स्वचालित अपडेट',
  },

  pt: {
    'nav.dashboard': 'Painel',
    'nav.myWork': 'Meu Trabalho',
    'nav.assetLookup': 'Buscar Ativos',
    'nav.workOrders': 'Ordens de Servico',
    'nav.myTeam': 'Minha Equipe',
    'nav.supervisor': 'Gestor de Equipe',
    'nav.helpCentre': 'Central de Ajuda',
    'nav.settings': 'Configuracoes',
    'nav.signOut': 'Sair',
    'nav.projects': 'Projetos',
    'nav.todos': 'A Fazer',
    'nav.credentials': 'Cofre de Credenciais',
    'common.save': 'Salvar',
    'common.cancel': 'Cancelar',
    'wo.title': 'Ordens de Servico',
    'wo.newNotification': 'Nova Notificacao',
    'wo.shopPaper': 'Folha de Oficina',
    'supervisor.approve': 'Aprovar',
    'supervisor.reject': 'Rejeitar',
    'settings.title': 'Configuracoes',
    'settings.language': 'Idioma',
    'auth.signIn': 'Entrar',
    'landing.getApp': 'Obter App',
    'landing.signIn': 'Entrar',
    'landing.heroSubtitle': 'Gestao profissional de ativos e rastreamento de ordens de servico. Otimize a manutencao, automatize o agendamento e mantenha sua equipe no caminho certo.',
    'landing.getStarted': 'Comecar',
    'landing.downloadApp': 'Baixar App',
    'landing.featuresTitle': 'Tudo o que Voce Precisa',
    'landing.featuresSubtitle': 'Uma plataforma completa de gestao de manutencao construida para operacoes reais.',
    'landing.feature1Title': 'Gestao de Ordens de Servico',
    'landing.feature2Title': 'Rastreamento de Ativos',
    'landing.feature3Title': 'Agendamento Recorrente',
    'landing.feature4Title': 'Equipe e Painel do Supervisor',
    'landing.feature5Title': 'Gestao de Documentos',
    'landing.feature6Title': 'Painel e Analitica',
    'landing.feature7Title': 'Confirmacoes de Tempo',
    'landing.feature8Title': 'Notificacoes por Email',
    'landing.feature9Title': 'Acesso Baseado em Funcoes',
    'landing.feature10Title': 'App Movel',
    'landing.feature11Title': 'Planejamento de Capacidade',
    'landing.feature12Title': 'Agendamento e Modelos',
    'landing.woTypesTitle': 'Tres Tipos de Ordens de Servico',
    'landing.workflowTitle': 'Fluxo de Aprovacao Simples',
    'landing.highlightsTitle': 'Feito para Equipes',
    'landing.pricingTitle': 'Precos Simples',
    'landing.mobileTitle': 'Leve com Voce',
    'landing.autoUpdate': 'Sempre baixa a versao mais recente — atualizacao automatica',
  },

  it: {
    'nav.dashboard': 'Pannello',
    'nav.myWork': 'Il Mio Lavoro',
    'nav.workOrders': 'Ordini di Lavoro',
    'nav.myTeam': 'Il Mio Team',
    'nav.supervisor': 'Gestione Team',
    'nav.helpCentre': 'Centro Assistenza',
    'nav.settings': 'Impostazioni',
    'nav.signOut': 'Esci',
    'nav.projects': 'Progetti',
    'nav.todos': 'Da Fare',
    'nav.credentials': 'Archivio Credenziali',
    'common.save': 'Salva',
    'common.cancel': 'Annulla',
    'wo.title': 'Ordini di Lavoro',
    'wo.newNotification': 'Nuova Notifica',
    'wo.shopPaper': 'Foglio Officina',
    'supervisor.approve': 'Approva',
    'supervisor.reject': 'Rifiuta',
    'settings.title': 'Impostazioni',
    'settings.language': 'Lingua',
    'auth.signIn': 'Accedi',
    'landing.getApp': 'Ottieni App',
    'landing.signIn': 'Accedi',
    'landing.heroSubtitle': 'Gestione professionale degli asset e tracciamento degli ordini di lavoro. Semplifica la manutenzione, automatizza la pianificazione e mantieni il tuo team in carreggiata.',
    'landing.getStarted': 'Inizia',
    'landing.downloadApp': 'Scarica App',
    'landing.featuresTitle': 'Tutto cio di cui hai bisogno',
    'landing.featuresSubtitle': 'Una piattaforma completa di gestione della manutenzione costruita per operazioni reali.',
    'landing.feature1Title': 'Gestione Ordini di Lavoro',
    'landing.feature2Title': 'Tracciamento Asset',
    'landing.feature3Title': 'Pianificazione Ricorrente',
    'landing.feature4Title': 'Team e Pannello Supervisore',
    'landing.feature5Title': 'Gestione Documenti',
    'landing.feature6Title': 'Dashboard e Analisi',
    'landing.feature7Title': 'Conferme Tempo',
    'landing.feature8Title': 'Notifiche Email',
    'landing.feature9Title': 'Accesso Basato sui Ruoli',
    'landing.feature10Title': 'App Mobile',
    'landing.feature11Title': 'Pianificazione Capacita',
    'landing.feature12Title': 'Pianificazione e Modelli',
    'landing.woTypesTitle': 'Tre Tipi di Ordini di Lavoro',
    'landing.workflowTitle': 'Flusso di Approvazione Semplice',
    'landing.highlightsTitle': 'Costruito per i Team',
    'landing.pricingTitle': 'Prezzi Semplici',
    'landing.mobileTitle': 'Portalo con Te',
    'landing.autoUpdate': 'Scarica sempre l\'ultima versione — aggiornamento automatico',
  },

  ko: {
    'nav.dashboard': '대시보드',
    'nav.myWork': '내 업무',
    'nav.workOrders': '작업 지시',
    'nav.myTeam': '내 팀',
    'nav.supervisor': '팀 관리',
    'nav.helpCentre': '도움말 센터',
    'nav.settings': '설정',
    'nav.signOut': '로그아웃',
    'nav.projects': '프로젝트',
    'nav.todos': '할 일',
    'nav.credentials': '자격 증명 보관함',
    'common.save': '저장',
    'common.cancel': '취소',
    'wo.title': '작업 지시',
    'wo.newNotification': '새 알림',
    'wo.shopPaper': '작업 전표',
    'supervisor.approve': '승인',
    'supervisor.reject': '거부',
    'settings.title': '설정',
    'settings.language': '언어',
    'auth.signIn': '로그인',
    'landing.getApp': '앱 받기',
    'landing.signIn': '로그인',
    'landing.heroSubtitle': '전문적인 자산 관리 및 작업 지시 추적. 유지보수를 간소화하고, 일정을 자동화하고, 팀을 관리하세요.',
    'landing.getStarted': '시작하기',
    'landing.downloadApp': '앱 다운로드',
    'landing.featuresTitle': '필요한 모든 것',
    'landing.featuresSubtitle': '실제 운영을 위해 구축된 완전한 유지보수 관리 플랫폼.',
    'landing.feature1Title': '작업 지시 관리',
    'landing.feature2Title': '자산 추적',
    'landing.feature3Title': '반복 스케줄링',
    'landing.feature4Title': '팀 및 관리자 패널',
    'landing.feature5Title': '문서 관리',
    'landing.feature6Title': '대시보드 및 분석',
    'landing.feature7Title': '시간 확인',
    'landing.feature8Title': '이메일 알림',
    'landing.feature9Title': '역할 기반 접근',
    'landing.feature10Title': '모바일 앱',
    'landing.feature11Title': '용량 계획',
    'landing.feature12Title': '스케줄링 및 템플릿',
    'landing.woTypesTitle': '세 가지 작업 지시 유형',
    'landing.workflowTitle': '간단한 승인 워크플로',
    'landing.highlightsTitle': '팀을 위해 구축',
    'landing.pricingTitle': '간단한 가격',
    'landing.mobileTitle': '휴대하세요',
    'landing.autoUpdate': '항상 최신 버전 다운로드 — 자동 업데이트',
  },

  ru: {
    'nav.dashboard': 'Панель управления',
    'nav.myWork': 'Моя работа',
    'nav.workOrders': 'Наряд-заказы',
    'nav.myTeam': 'Моя команда',
    'nav.supervisor': 'Управление командой',
    'nav.helpCentre': 'Центр помощи',
    'nav.settings': 'Настройки',
    'nav.signOut': 'Выйти',
    'nav.projects': 'Проекты',
    'nav.todos': 'Задачи',
    'nav.credentials': 'Хранилище Паролей',
    'common.save': 'Сохранить',
    'common.cancel': 'Отмена',
    'wo.title': 'Наряд-заказы',
    'wo.newNotification': 'Новое уведомление',
    'wo.shopPaper': 'Наряд на работу',
    'supervisor.approve': 'Одобрить',
    'supervisor.reject': 'Отклонить',
    'settings.title': 'Настройки',
    'settings.language': 'Язык',
    'auth.signIn': 'Войти',
    'landing.getApp': 'Скачать приложение',
    'landing.signIn': 'Войти',
    'landing.heroSubtitle': 'Профессиональное управление активами и отслеживание нарядов. Оптимизируйте обслуживание, автоматизируйте планирование и держите команду в курсе.',
    'landing.getStarted': 'Начать',
    'landing.downloadApp': 'Скачать приложение',
    'landing.featuresTitle': 'Все что вам нужно',
    'landing.featuresSubtitle': 'Полная платформа управления обслуживанием для реальных операций.',
    'landing.feature1Title': 'Управление нарядами',
    'landing.feature2Title': 'Отслеживание активов',
    'landing.feature3Title': 'Периодическое планирование',
    'landing.feature4Title': 'Команда и панель руководителя',
    'landing.feature5Title': 'Управление документами',
    'landing.feature6Title': 'Панель управления и аналитика',
    'landing.feature7Title': 'Подтверждения времени',
    'landing.feature8Title': 'Уведомления по email',
    'landing.feature9Title': 'Доступ на основе ролей',
    'landing.feature10Title': 'Мобильное приложение',
    'landing.feature11Title': 'Планирование мощностей',
    'landing.feature12Title': 'Планирование и шаблоны',
    'landing.woTypesTitle': 'Три типа нарядов',
    'landing.workflowTitle': 'Простой процесс утверждения',
    'landing.highlightsTitle': 'Создано для команд',
    'landing.pricingTitle': 'Простые цены',
    'landing.mobileTitle': 'Возьмите с собой',
    'landing.autoUpdate': 'Всегда загружает последнюю версию — автоматическое обновление',
  },

  nl: {
    'nav.dashboard': 'Dashboard', 'nav.myWork': 'Mijn Werk', 'nav.assetLookup': 'Activa Zoeken', 'nav.workOrders': 'Werkorders',
    'nav.myTeam': 'Mijn Team', 'nav.supervisor': 'Teammanager', 'nav.helpCentre': 'Helpcentrum', 'nav.adminPanel': 'Beheer',
    'nav.settings': 'Instellingen', 'nav.signOut': 'Uitloggen', 'nav.projects': 'Projecten', 'nav.todos': 'Taken', 'nav.credentials': 'Wachtwoordkluis',
    'common.save': 'Opslaan', 'common.cancel': 'Annuleren', 'common.delete': 'Verwijderen', 'common.edit': 'Bewerken', 'common.close': 'Sluiten',
    'common.search': 'Zoeken', 'common.loading': 'Laden...', 'common.noResults': 'Geen resultaten', 'common.confirm': 'Bevestigen', 'common.back': 'Terug',
    'common.export': 'Exporteren', 'common.all': 'Alle', 'common.yes': 'Ja', 'common.no': 'Nee',
    'wo.title': 'Werkorders', 'wo.status': 'Status', 'wo.priority': 'Prioriteit', 'wo.type': 'Type', 'wo.assignedTo': 'Toegewezen aan',
    'wo.dueDate': 'Vervaldatum', 'wo.description': 'Beschrijving', 'wo.operations': 'Bewerkingen', 'wo.comments': 'Opmerkingen', 'wo.history': 'Historie',
    'settings.title': 'Instellingen', 'settings.language': 'Taal', 'settings.theme': 'Thema', 'settings.notifications': 'E-mailmeldingen',
    'auth.signIn': 'Inloggen', 'auth.email': 'E-mail', 'auth.password': 'Wachtwoord', 'auth.forgotPassword': 'Wachtwoord vergeten?', 'auth.resetPassword': 'Wachtwoord resetten',
    'dashboard.welcome': 'Welkom terug, {name}',
  },

  pl: {
    'nav.dashboard': 'Panel', 'nav.myWork': 'Moja Praca', 'nav.assetLookup': 'Szukaj Zasobów', 'nav.workOrders': 'Zlecenia Pracy',
    'nav.myTeam': 'Mój Zespół', 'nav.supervisor': 'Menedżer Zespołu', 'nav.helpCentre': 'Centrum Pomocy', 'nav.adminPanel': 'Administracja',
    'nav.settings': 'Ustawienia', 'nav.signOut': 'Wyloguj', 'nav.projects': 'Projekty', 'nav.todos': 'Zadania', 'nav.credentials': 'Skarbiec Haseł',
    'common.save': 'Zapisz', 'common.cancel': 'Anuluj', 'common.delete': 'Usuń', 'common.edit': 'Edytuj', 'common.close': 'Zamknij',
    'common.search': 'Szukaj', 'common.loading': 'Ładowanie...', 'common.noResults': 'Brak wyników', 'common.confirm': 'Potwierdź', 'common.back': 'Wstecz',
    'common.export': 'Eksportuj', 'common.all': 'Wszystkie', 'common.yes': 'Tak', 'common.no': 'Nie',
    'wo.title': 'Zlecenia Pracy', 'wo.status': 'Status', 'wo.priority': 'Priorytet', 'wo.type': 'Typ', 'wo.assignedTo': 'Przypisane do',
    'wo.dueDate': 'Termin', 'wo.description': 'Opis', 'wo.operations': 'Operacje', 'wo.comments': 'Komentarze', 'wo.history': 'Historia',
    'settings.title': 'Ustawienia', 'settings.language': 'Język', 'settings.theme': 'Motyw', 'settings.notifications': 'Powiadomienia e-mail',
    'auth.signIn': 'Zaloguj', 'auth.email': 'E-mail', 'auth.password': 'Hasło', 'auth.forgotPassword': 'Nie pamiętasz hasła?', 'auth.resetPassword': 'Zresetuj hasło',
    'dashboard.welcome': 'Witaj ponownie, {name}',
  },

  sv: {
    'nav.dashboard': 'Instrumentpanel', 'nav.myWork': 'Mitt Arbete', 'nav.assetLookup': 'Sök Tillgångar', 'nav.workOrders': 'Arbetsordrar',
    'nav.myTeam': 'Mitt Team', 'nav.supervisor': 'Teamchef', 'nav.helpCentre': 'Hjälpcenter', 'nav.adminPanel': 'Administration',
    'nav.settings': 'Inställningar', 'nav.signOut': 'Logga ut', 'nav.projects': 'Projekt', 'nav.todos': 'Att göra', 'nav.credentials': 'Lösenordsvalv',
    'common.save': 'Spara', 'common.cancel': 'Avbryt', 'common.delete': 'Radera', 'common.edit': 'Redigera', 'common.close': 'Stäng',
    'common.search': 'Sök', 'common.loading': 'Laddar...', 'common.noResults': 'Inga resultat', 'common.confirm': 'Bekräfta', 'common.back': 'Tillbaka',
    'common.export': 'Exportera', 'common.all': 'Alla', 'common.yes': 'Ja', 'common.no': 'Nej',
    'wo.title': 'Arbetsordrar', 'wo.status': 'Status', 'wo.priority': 'Prioritet', 'wo.type': 'Typ', 'wo.assignedTo': 'Tilldelad till',
    'wo.dueDate': 'Förfallodatum', 'wo.description': 'Beskrivning', 'wo.operations': 'Operationer', 'wo.comments': 'Kommentarer', 'wo.history': 'Historik',
    'settings.title': 'Inställningar', 'settings.language': 'Språk', 'settings.theme': 'Tema', 'settings.notifications': 'E-postmeddelanden',
    'auth.signIn': 'Logga in', 'auth.email': 'E-post', 'auth.password': 'Lösenord', 'auth.forgotPassword': 'Glömt lösenord?', 'auth.resetPassword': 'Återställ lösenord',
    'dashboard.welcome': 'Välkommen tillbaka, {name}',
  },

  tr: {
    'nav.dashboard': 'Panel', 'nav.myWork': 'İşlerim', 'nav.assetLookup': 'Varlık Ara', 'nav.workOrders': 'İş Emirleri',
    'nav.myTeam': 'Takımım', 'nav.supervisor': 'Takım Yöneticisi', 'nav.helpCentre': 'Yardım Merkezi', 'nav.adminPanel': 'Yönetim',
    'nav.settings': 'Ayarlar', 'nav.signOut': 'Çıkış', 'nav.projects': 'Projeler', 'nav.todos': 'Görevler', 'nav.credentials': 'Şifre Kasası',
    'common.save': 'Kaydet', 'common.cancel': 'İptal', 'common.delete': 'Sil', 'common.edit': 'Düzenle', 'common.close': 'Kapat',
    'common.search': 'Ara', 'common.loading': 'Yükleniyor...', 'common.noResults': 'Sonuç yok', 'common.confirm': 'Onayla', 'common.back': 'Geri',
    'common.export': 'Dışa Aktar', 'common.all': 'Tümü', 'common.yes': 'Evet', 'common.no': 'Hayır',
    'wo.title': 'İş Emirleri', 'wo.status': 'Durum', 'wo.priority': 'Öncelik', 'wo.type': 'Tür', 'wo.assignedTo': 'Atanan',
    'wo.dueDate': 'Bitiş Tarihi', 'wo.description': 'Açıklama', 'wo.operations': 'İşlemler', 'wo.comments': 'Yorumlar', 'wo.history': 'Geçmiş',
    'settings.title': 'Ayarlar', 'settings.language': 'Dil', 'settings.theme': 'Tema', 'settings.notifications': 'E-posta Bildirimleri',
    'auth.signIn': 'Giriş Yap', 'auth.email': 'E-posta', 'auth.password': 'Şifre', 'auth.forgotPassword': 'Şifremi unuttum?', 'auth.resetPassword': 'Şifreyi Sıfırla',
    'dashboard.welcome': 'Tekrar hoş geldin, {name}',
  },

  id: {
    'nav.dashboard': 'Dasbor', 'nav.myWork': 'Pekerjaan Saya', 'nav.assetLookup': 'Cari Aset', 'nav.workOrders': 'Perintah Kerja',
    'nav.myTeam': 'Tim Saya', 'nav.supervisor': 'Manajer Tim', 'nav.helpCentre': 'Pusat Bantuan', 'nav.adminPanel': 'Administrasi',
    'nav.settings': 'Pengaturan', 'nav.signOut': 'Keluar', 'nav.projects': 'Proyek', 'nav.todos': 'Tugas', 'nav.credentials': 'Brankas Kredensial',
    'common.save': 'Simpan', 'common.cancel': 'Batal', 'common.delete': 'Hapus', 'common.edit': 'Edit', 'common.close': 'Tutup',
    'common.search': 'Cari', 'common.loading': 'Memuat...', 'common.noResults': 'Tidak ada hasil', 'common.confirm': 'Konfirmasi', 'common.back': 'Kembali',
    'common.export': 'Ekspor', 'common.all': 'Semua', 'common.yes': 'Ya', 'common.no': 'Tidak',
    'wo.title': 'Perintah Kerja', 'wo.status': 'Status', 'wo.priority': 'Prioritas', 'wo.type': 'Tipe', 'wo.assignedTo': 'Ditugaskan kepada',
    'wo.dueDate': 'Tenggat', 'wo.description': 'Deskripsi', 'wo.operations': 'Operasi', 'wo.comments': 'Komentar', 'wo.history': 'Riwayat',
    'settings.title': 'Pengaturan', 'settings.language': 'Bahasa', 'settings.theme': 'Tema', 'settings.notifications': 'Notifikasi Email',
    'auth.signIn': 'Masuk', 'auth.email': 'Email', 'auth.password': 'Kata Sandi', 'auth.forgotPassword': 'Lupa kata sandi?', 'auth.resetPassword': 'Reset Kata Sandi',
    'dashboard.welcome': 'Selamat datang kembali, {name}',
  },

  vi: {
    'nav.dashboard': 'Bảng Điều Khiển', 'nav.myWork': 'Công Việc Của Tôi', 'nav.assetLookup': 'Tìm Tài Sản', 'nav.workOrders': 'Lệnh Công Tác',
    'nav.myTeam': 'Đội Của Tôi', 'nav.supervisor': 'Quản Lý Đội', 'nav.helpCentre': 'Trung Tâm Trợ Giúp', 'nav.adminPanel': 'Quản Trị',
    'nav.settings': 'Cài Đặt', 'nav.signOut': 'Đăng Xuất', 'nav.projects': 'Dự Án', 'nav.todos': 'Việc Cần Làm', 'nav.credentials': 'Kho Mật Khẩu',
    'common.save': 'Lưu', 'common.cancel': 'Hủy', 'common.delete': 'Xóa', 'common.edit': 'Sửa', 'common.close': 'Đóng',
    'common.search': 'Tìm', 'common.loading': 'Đang tải...', 'common.noResults': 'Không có kết quả', 'common.confirm': 'Xác nhận', 'common.back': 'Quay lại',
    'common.export': 'Xuất', 'common.all': 'Tất cả', 'common.yes': 'Có', 'common.no': 'Không',
    'wo.title': 'Lệnh Công Tác', 'wo.status': 'Trạng thái', 'wo.priority': 'Độ ưu tiên', 'wo.type': 'Loại', 'wo.assignedTo': 'Giao cho',
    'wo.dueDate': 'Hạn', 'wo.description': 'Mô tả', 'wo.operations': 'Thao tác', 'wo.comments': 'Bình luận', 'wo.history': 'Lịch sử',
    'settings.title': 'Cài Đặt', 'settings.language': 'Ngôn ngữ', 'settings.theme': 'Chủ đề', 'settings.notifications': 'Thông báo email',
    'auth.signIn': 'Đăng nhập', 'auth.email': 'Email', 'auth.password': 'Mật khẩu', 'auth.forgotPassword': 'Quên mật khẩu?', 'auth.resetPassword': 'Đặt lại mật khẩu',
    'dashboard.welcome': 'Chào mừng trở lại, {name}',
  },
};

export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Espanol', flag: '🇪🇸' },
  { code: 'fr', name: 'Francais', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', name: 'Portugues', flag: '🇧🇷' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
  { code: 'tr', name: 'Turkce', flag: '🇹🇷' },
  { code: 'id', name: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
];

export default translations;
